import styled from 'styled-components';
import { Loading } from '@/components/SurfingLoading';
import { Checkout } from '@/templates/Checkout';
import { PreviewLoginCta } from './Preview';
import { Notice, Page, Title } from './styles';
import { usePayReservationLogic } from './logic/usePayReservationLogic';

const PageContainer = styled.div`
    body #root header {
        display: none;
    }
    height: 100%;

    > div {
        height: 100%;
        justify-content: center;
    }
`;

const PayReservation = () => {
    const { state, openLogin } = usePayReservationLogic();

    switch (state.status) {
        case 'loading':
            return <Loading />;
        case 'notFound':
            return (
                <Page>
                    <Title>Link não encontrado</Title>
                    <Notice>
                        O link de pagamento informado não foi encontrado ou
                        expirou.
                    </Notice>
                </Page>
            );
        case 'error':
            return (
                <Page>
                    <Title>Algo deu errado</Title>
                    <Notice>{state.message}</Notice>
                </Page>
            );
        case 'preview':
            return (
                <PageContainer>
                    <Checkout
                        shouldHideRecommendations={true}
                        shouldBlockEditing={true}
                        isPaymentLink={true}
                        forcedCheckoutId={state.forcedCheckoutId}
                        previewSlot={<PreviewLoginCta onLogin={openLogin} />}
                    />
                </PageContainer>
            );
        case 'checkout':
            return (
                <PageContainer>
                    <Checkout
                        shouldHideRecommendations={true}
                        shouldBlockEditing={true}
                        isPaymentLink={true}
                        forcedCheckoutId={state.forcedCheckoutId}
                        showReservationPeriod={true}
                    />
                </PageContainer>
            );
    }
};

export default PayReservation;
